import BackToTop from "@quarkly/community-kit/BackToTop";
export default BackToTop;